<div></div>
<h1 mat-dialog-title tabindex="-1" cdkFocusInitial>Login Alert</h1>
<div mat-dialog-content>
    <p>PLEASE LOGIN FIRST.</p>
</div>
<div fxLayoutAlign="center" fxLayout="column" fxLayout.gt-xs="row" class="button-group" fxLayoutGap="20px">
    <a mat-flat-button color="primary" mat-dialog-close (click)="loginToCheckout()">Login</a>
    <a mat-flat-button color="primary" mat-dialog-close>Cancel</a>
</div>